module.exports = __webpack_public_path__ + "img/features03-03.4fa682b.webp";